var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":"/alerts"}},[_c('div',{staticClass:"bell"},[_c('i',{staticClass:"far fa-bell"})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }